<template>
    <!--    列表组件-->
    <ul class="newStyleList">
        <li v-for="(item,index) in policydata" :key="index" @click="inforClick(index)"
        :class="(index<policydata.length-1)?'speaceLi':''"
        >
            <div class="newStyleClassify">
                <el-image :src="item.thumbnailUrl" fit="cover"></el-image>
                <p class="defaultTitle classifyTitle">{{item.titleName}}</p>
                <p class="smallTitle">{{item.synopsis}}</p>
            </div>
            
        </li> 
    </ul>
</template>

<script>
    export default {
        name: "lp-newStyleList",
        props:['policydata'],
        data(){
            return{
                noImg:require('../../assets/images/test.jpg')
            }
        },
        methods:{
            inforClick(index){
                var path=this.policydata[index];
                //查看详情
                this.$router.push({path:"/detail/"+path.id,query:{type:5,origin:true}})
            }
        }
    }
</script>

<style lang="less" scoped>
    .newStyleList{
        width: @contentWidth;
        display: flex;
        flex-wrap: wrap;
        @liWidth:230px;
        @imgWidth:210px;
        .speaceLi{
            margin-right: 10px;
        }
        li{
            cursor: pointer;
            width: @liWidth;
            height: 280px;
            margin-top: 18px;
            border: 1px solid #D8D8D8;
            position: relative;
            .newStyleClassify{
                position: absolute;
                left: 10px;
                top: 20px;
                width: @imgWidth;
                overflow: hidden;
                /*图片*/
                .el-image{
                    width: @imgWidth;
                    height: 140px;
                    transition: 1s;
                }
                /*鼠标悬浮图片-放大*/
                .el-image:hover {
                    transform: scale(1.2);
                } 
                /*标题*/
                .classifyTitle{
                    text-overflow:ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    cursor: pointer;
                    
                    width: 100%;
                    line-height: 20px;
                    height: 20px;
                    margin-top: 20px;
                    font-size: 16px;
                    color: #333;
                    font-family: MicrosoftYaHei-Bold;
                }
                .classifyTitle:hover{
                    color: @hoverDefaultColor;
                }
                // 介绍
                .smallTitle{ 
                    /*最多2行-省略号*/
                    display: -webkit-box;
                    text-overflow:ellipsis;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    -webkit-line-clamp: 2;

                    width: 100%;
                    height: 36px;
                    margin-top: 20px;
                    line-height: 18px;
                    font-size: 12px;
                    color: #333;
                    font-family: MicrosoftYaHei;

                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/newstylelist/index.vue